export default __webpack_public_path__ + "static/media/bgimg.a06adfa6.svg";